
    import axios from 'axios';
    
   
    
const utils = { 
    async fetchEmployees() {
        return axios.get('api/employees')
            .then(response => response.data)
            .catch(error => {
                throw error;
            });
    },
   async getCompanyOwner(id) {
        await axios.get('api/company-owner', { params: { company_id: id } })
          .then(response => {
            return response.data
        })
          .catch(error => {
            throw error;
          });
      },
     
}

export default utils;

